import type { BoxProps, CardMediaProps } from "@mui/material";
import { Box, CardMedia } from "@mui/material";
import type { ImgHTMLAttributes } from "react";
import {
  storageUrlWithCredentials,
  useStorageUrlWithCredentials,
} from "../components/imagesPreview/storageUrlWithCredentials";
import type { ImageFlavour } from "../publicPackages/publicPackagesApi";

export interface ImageDTO {
  readonly id: string;
  readonly name: string;
  readonly thumbnail: {
    readonly url: string;
  };
  readonly original: {
    readonly url: string;
  };
  readonly www: {
    readonly url: string;
  };
  readonly flavours: Partial<Record<ImageFlavour, { readonly url: string }>>;
}

export function CardMediaImg({
  imageUrl,
  ...rest
}: { imageUrl: string | undefined } & CardMediaProps & ImgHTMLAttributes<HTMLInputElement>) {
  const thumbnailUrl = useStorageUrlWithCredentials(imageUrl);
  return <CardMedia component="img" style={{ backgroundColor: "lightgray" }} image={thumbnailUrl} {...rest} />;
}

export function ImageBox({
  image,
  onClick,
  ...rest
}: {
  image: ImageDTO;
  onClick: (imageSrc: string) => void;
} & Omit<BoxProps, "onClick">) {
  const thumbnailUrl = useStorageUrlWithCredentials(image.www.url);
  return (
    <BoxImg
      src={thumbnailUrl}
      onClick={() => {
        storageUrlWithCredentials(image.original.url).then((url) => {
          if (url) {
            onClick(url);
          }
        });
      }}
      {...rest}
    />
  );
}

function BoxImg(props: BoxProps & { src: string | undefined }) {
  return <Box component="img" {...props} />;
}
